import { atom } from 'recoil'
import { DetectionType } from '../../../../api/generated'

export const SelectedBrushAtom = atom<DetectionType | undefined>({
  key: 'selectedBrush',
  default: undefined,
})
